import { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { TextField } from '@mui/material';

export interface IDateTimeInputProps {
    label: string;
    value: Dayjs;
    onChange: (value: Dayjs) => void;
}

export function DateTimeInput(props: IDateTimeInputProps) {

    const handleChange = (event: any) => {
        if (!event) {
            return;
        }

        const value = event as Dayjs;
        if (!value) {
            return;
        }

        props.onChange(value);
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker                    
                PopperProps={{disablePortal: true, style: {zIndex: 10000}}}                                        
                label={props.label}
                value={props.value}                    
                onChange={handleChange}
                ampm={false}
                renderInput={(params) => <TextField {...params} />}
            />
        </LocalizationProvider>
    )
}